import { render, staticRenderFns } from "./MonederoSet.vue?vue&type=template&id=6c25f106&"
import script from "./MonederoSet.vue?vue&type=script&lang=js&"
export * from "./MonederoSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports